import "core-js/stable";
import "regenerator-runtime/runtime";
import select from "dom-select";
import LazyLoad from "lazyload";
import Swiper from "swiper/bundle";
import "../scss/style.scss";
import BSN from "bootstrap.native/dist/bootstrap-native.esm";
import Dropdown from "bootstrap/js/src/dropdown";// Added to resolve issue 117
/*
import Collapse from 'bootstrap.native/dist/components/collapse-native.esm.js';
import Tab from 'bootstrap.native/dist/components/tab-native.esm.js';
import Dropdown from 'bootstrap.native/dist/components/dropdown-native.esm.js';
import Modal from 'bootstrap.native/dist/components/modal-native.esm.js';
*/
import Tooltip from "./vendors/tooltip-native.esm.js";
import GLightbox from "glightbox";
// import barba from "@barba/core";
// import barbaPrefetch from "@barba/prefetch";
import { MatchHeight } from "js-match-height";
//import flatpickr from "flatpickr";
//import rangePlugin from 'flatpickr/dist/plugins/rangePlugin';
//import { easepick } from '@easepick/bundle';
import { easepick } from "@easepick/core";
import { RangePlugin } from "@easepick/range-plugin";
import { TimePlugin } from "@easepick/time-plugin";
// import { LockPlugin } from "@easepick/lock-plugin";
// import { AmpPlugin } from "@easepick/amp-plugin";
// import { PresetPlugin } from "@easepick/bundle";
import axios from "./helpers/axios";
import htmx from 'htmx.org';
import MemberDirectory from "./svelte-components/member-directory/member-directory.svelte";
import DentistSearch from "./svelte-components/dentist-search/dentist-search.svelte";
import SlimSelect from "slim-select";
import ClassifiedAdsFilters from "./svelte-components/classified-ads-filters/classified-ads-filters.svelte";
import InactivityModal from "./svelte-components/inactivity-modal/inactivity-modal.svelte"
import { isNil } from "lodash";
import { findParentElement, findSubtotalElement } from "./helpers/util.js";
import IMask from 'imask';
window.isSetUpAutoCompleteCalled = false;
window.activeLightbox = null;
(function (doc, win) {
  const app = {
    lazyload: null,
    swipers: [],
    mainMenu: doc.getElementById("main-menu"),
    mobileMainMenu: doc.getElementById("mobile-main-menu"),
    matchMinLg: win.matchMedia("(min-width: 1024px)"),
    matchHeight: doc.querySelector(".match-height"),
    initLazy: function () {
      if (this.lazyload) this.lazyload.destroy();
      const images = select.all("[data-src]");
      this.lazyload = new LazyLoad(images);
    },
    initSwipers: function (parent) {
      this.swipers.forEach((sw) => sw.destroy());
      select.all(".swiper-container.swiper-full", parent).forEach((sw) => {
        if (sw.querySelectorAll(".swiper-slide div.inner").length > 1) {
          this.swipers.push(
            new Swiper(sw, {
              direction: "horizontal",
              loop: true,
              autoplay: {
                delay: 8000,
                disableOnInteraction: true,
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            })
          );
        } else {
          this.swipers.push(
            new Swiper(sw, {
              direction: "horizontal",
              loop: false,
              watchOverflow: true,
              autoplay: {
                delay: 8000,
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
            })
          );
        }
        // Improve Swiper link behaviour https://github.com/thecohorts/nzda-craft/issues/107
        var links = sw.querySelectorAll(".swiper-wrapper .inner a"); // Exclude prev / next arrows
        Array.prototype.forEach.call(links, function (el, j) {
          var link = links[j];
          link.addEventListener("click", (event) => {
            sw.swiper.autoplay.stop();
            app.pageFader("add");
          });
        });
      });
      setTimeout(function () {
        app.swipers.forEach((sw) => sw.update());
      }, 200);
      // Hide the fader in case the back button is used (Webkit)
      window.addEventListener("unload", (event) => {
        app.pageFader("remove");
      });
    },
    initNavTabs: function () {
      const navTabs = doc.querySelectorAll(".nav-tabs");
      Array.from(navTabs).forEach((navTabs) => {
        var myTabsCollection = navTabs.getElementsByTagName("a");
        Array.from(myTabsCollection).forEach((tab) => new BSN.Tab(tab));
      });
    },
    homeTabs: function () {
      const homeTabs = doc.querySelectorAll(".home-tabs");
      Array.from(homeTabs).forEach((homeTabs) => {
        var homeTabsCollection = homeTabs.getElementsByTagName("a");
        Array.from(homeTabsCollection).forEach((tab) => new BSN.Tab(tab));
      });
    },
    initMobileDropdownToggles: function () {
      if (this.mobileMainMenu) {
        const mobileDropdownToggles =
          this.mobileMainMenu.getElementsByClassName("mobile-dropdown-toggle");
        Array.from(mobileDropdownToggles).forEach(
          (mobileDropdownToggle) => new BSN.Dropdown(mobileDropdownToggle)
        );
      }
    },
    initHoverDropDown: function () {
      if (this.mainMenu) {
        const hoverTriggers = this.mainMenu.querySelectorAll(
          ".dropdown:not(.active)"
        );
        const showDropdown = (event) => {
          event.target.classList.add("show");
          event.target.querySelector(".dropdown-menu").classList.add("show");
          event.target
            .querySelector(".dropdown-toggle")
            .setAttribute("aria-expanded", true);
        };
        const hideDropdown = (event) => {
          event.target.classList.remove("show");
          event.target.querySelector(".dropdown-menu").classList.remove("show");
          event.target
            .querySelector(".dropdown-toggle")
            .setAttribute("aria-expanded", false);
        };
        const enableHoverDropDown = (hoverTriggers) => {
          Array.from(hoverTriggers).forEach((hoverTrigger) => {
            hoverTrigger.addEventListener("mouseenter", showDropdown);
            hoverTrigger.addEventListener("mouseleave", hideDropdown);
          });
        };
        const disableHoverDropDown = (hoverTriggers) => {
          Array.from(hoverTriggers).forEach((hoverTrigger) => {
            hoverTrigger.removeEventListener("mouseenter", showDropdown);
            hoverTrigger.removeEventListener("mouseleave", hideDropdown);
          });
        };
        if (this.matchMinLg.matches) {
          enableHoverDropDown(hoverTriggers);
        }
        this.matchMinLg.addEventListener("change", (matchMinLg) => {
          if (matchMinLg.matches) {
            enableHoverDropDown(hoverTriggers);
          } else {
            disableHoverDropDown(hoverTriggers);
          }
        });
      }
    },
    matchHeights: function () {
      if (this.matchHeight) {
        const matchHeight = new MatchHeight(".match-height");
      }
    },
    /*
    initMobileMenuCollapse: function() {
      if ( doc.querySelectorAll( '.collapse' ).length > 0 ) {
        new Collapse('.collapse')
      }
    },*/
    formValidation() {
      /** TODO - more/better validation, href fields etc.
       * add data-url to fields to validate a url.
       * **/
      const fields = ".slim-select,.form-control,form-control-file";
      if (doc.querySelectorAll(fields).length > 0) {
        const formFields = document.querySelectorAll(fields);

        formFields.forEach((item) => {
          if (typeof item.dataset.required != "undefined") {
            /**
             * so we get erros on the hidden selects, so peeps know a selection from a slim select field is required.
             */
            item.setAttribute("required", true);

            //so it's not run twice.
            item.removeAttribute("data-required");
          }

          if (typeof item.dataset.validateUrl != "undefined") {
            /**
             * Make sure fields with data-url have a valid url.
             */
            item.setAttribute("pattern", "https?://.+");
            item.setAttribute(
              "oninvalid",
              "this.setCustomValidity('Please enter a valid url starting with https://')"
            );
            item.setAttribute("onchange", "this.setCustomValidity('')");

            //so it's not run twice.
            item.removeAttribute("data-validate-url");
          }
        });
      }

      //non-freeform forms input validation error logic
      const inputFieldsWithErrors = document.querySelectorAll(
        '[method="post"]:not([data-freeform]) input + ul.errors'
      ); // Previous version '[method="post"]:not([data-freeform]) input:has(+ ul.errors)' caused not valid selector error from this on Firefox and caused Courses & Events filters to break when changed (Tim A)
      inputFieldsWithErrors.forEach((el) => {
        el = el.previousElementSibling; // Also tweaked
        el.classList.add("is-invalid");
        el.addEventListener("blur", (e) => {
          el.classList.remove("is-invalid");
          if (el.nextElementSibling) el.nextElementSibling.remove();
        });
      });
    },
  initMemberDirectory(){
    if (document.getElementById("member-directory-component")) {
      const el = document.getElementById("member-directory-component");
      // const dataset = Object.assign({}, el.dataset);
      new MemberDirectory({
        target: el,
      });
    }
  },
  initInactivityModal(){
    if (document.getElementById("inactivity-modal-component")) {
      const el = document.getElementById("inactivity-modal-component");
   
      new InactivityModal({
        target: el,
      });
    }
  },
  initClassifiedAdsFilters(){
    if (document.getElementById("classified-ads-filters-component")) {
      const el = document.getElementById("classified-ads-filters-component");
      const dataset = Object.assign({}, el.dataset);

        new ClassifiedAdsFilters({
          target: el,
          props: {
            categoriesOne: dataset.categoriesOne,
            categoriesTwo: dataset.categoriesTwo,
          },
        });
      }
    },
    initDentistSearch() {
      if (document.getElementById("dentist-search-component")) {
        const el = document.getElementById("dentist-search-component");
        // const dataset = Object.assign({}, el.dataset);
        new DentistSearch({
          target: el,
        });
      }
    },
    initSlimSelect() {
      if (document.querySelectorAll(".slim-select:not(.ss-ajax)").length > 0) {
        const selects = document.querySelectorAll(".slim-select:not(.ss-ajax)");

        //console.log(".slim-select:not(.ss-ajax)", "Number: " + selects.length);

        selects.forEach((item) => {
          // console.log(
          //   "checking for class ss-run",
          //   item.classList.contains("ss-run"),
          //   item.classList
          // );
          if (item.classList.contains("ss-run") == false) {
            //console.log("has not been initted yet - run");
            //if it does - then it's allready a slim select and doesn't need to be inited again
            item.classList.add("ss-run");

            const placeholder = item.getAttribute("placeholder");
            const slimSelect = new SlimSelect({
              select: item,
              settings: {
                searchPlaceholder: placeholder,
                openPosition: "down",
                searchHighlight: true,
              },
            });

            // if (slimSelect.slim.multiSelected) {
            //   slimSelect.slim.multiSelected.values.after(
            //     slimSelect.slim.search.container
            //   );
            // }
            const clearSelect = doc.getElementById("clear-select");
            if (clearSelect) {
              clearSelect.addEventListener("click", (e) => {
                // alert("clearing select");
                slimSelect.setSelected([]);
              });
            }
            // Populate slim select on page load if ?filters= query string exists
            var query_str = new URLSearchParams(window.location.search);
            if (query_str.has("filters")) {
              var tag_arr = query_str.get("filters").split(",");
              slimSelect.setSelected(tag_arr);
            }
            // Add a class if any values are present
            var filters_applied = item.querySelectorAll("option:checked");
            if (filters_applied.length) {
              item.classList.add("ss-applied");
            }
            item.style.display = "block";
            item.style.border = "0";
            item.style.height = "1px";
            item.style.overflow = "hidden";
            item.style.padding = "0";
            item.style.position = "absolute";
            item.style.width = "1px";
            item.style.whiteSpace = "nowrap";
          }
        });

        const nzdaOnlyButton = doc.getElementById("nzda-only");
        let nzda = 0;
        if (nzdaOnlyButton) {
          nzdaOnlyButton.addEventListener("click", (e) => {
            nzdaOnlyButton.classList.toggle("btn-dark");
            if (nzda == 0) {
              nzda = 1;
            } else {
              nzda = 0;
            }
            runfilters();
          });
        }

        function runfilters() {
          app.initSlimSelect();
          //console.log("sprig should be controlling this");
          return;
          console.log(nzdaOnlyButton);
          if (nzdaOnlyButton == null) return;

          // Get the tags
          var query_str = "";
          selects.forEach((item) => {
            var tags =
              item.nextElementSibling.querySelectorAll(".ss-value-text");
            if (tags.length > 0) {
              // If selection has been made apply a class to help UI CSS
              item.classList.add("selection-made");
              // Resume
              if (query_str == "") {
                query_str = "?";
              } else {
                query_str += "&";
              }
              query_str += item.getAttribute("data-query-param") + "=";
              for (var i = 0; i < tags.length; i++) {
                if (i > 0) {
                  query_str += ",";
                }
                var filter = tags[i].textContent;
                var tag;
                item.querySelectorAll("option").forEach((option) => {
                  if (option.textContent == filter) {
                    tag = option
                      .getAttribute("value")
                      .replace(/\s+/g, "-")
                      .toLowerCase();
                  }
                });
                query_str += tag;
              }
            } else {
              item.classList.remove("selection-made");
            }
          });
          if (nzda == 1) {
            query_str += "&nzda=1";
          }
          console.log(query_str);
          // Store the AJAX container element
          var results_el = document.querySelector(".ajax-results-wrapper");
          // Create a div outside the DOM to load the AJAX news listing HTML into that we can then extract only the listing container HTML from
          // I can't see your ghost divs, bro
          var ghost_div = document.createElement("div");
          // Make the AJAX request and handle the response
          var request = new XMLHttpRequest();
          // Request the appropriate URL, NB must work on both about-us/news and /public/media/nzda-in-the-news and /courses-events/courses-events-search
          if (query_str === "") {
            request.open("GET", location.pathname, true);
            document.body.classList.remove("filters-on");
          } else {
            request.open("GET", location.pathname + query_str, true);
            document.body.classList.add("filters-on"); //Allows display:none on courses hero slider.
          }
          // Could be some sort of loading element here
          // results_el.innerHTML = '<h3>Loading</h3>';
          // Process response
          request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
              // Success, put it in the ghost div to get the listing HTML
              ghost_div.innerHTML = this.response;
              if (ghost_div.querySelector(".ajax-results-wrapper")) {
                results_el.innerHTML = ghost_div.querySelector(
                  ".ajax-results-wrapper"
                ).innerHTML;

                app.initSlimSelect();
                app.formValidation();
                // Update the browser URL
                if (query_str === "") {
                  window.history.replaceState(
                    null,
                    document.title,
                    location.pathname
                  );
                } else {
                  window.history.replaceState(
                    null,
                    document.title,
                    location.pathname + query_str
                  );
                  document.body.classList.add("filters-on");
                }
              }
            } else {
              // Connection made, but another error occurred
            }
            var myCollapseInit = new BSN.Collapse(".collapse"); //Should renitialize Bootstrap Native collapse - not working!!
          };
          request.onerror = function () {
            // There was a connection error
          };
          request.send();
        }
      }
    },
    initTooltip() {
      const tooltipElements = doc.querySelectorAll('[data-toggle="tooltip"]');
      Array.from(tooltipElements).map((tE) => {
        const tooltip = new Tooltip(tE);
        tE.addEventListener("click", function (e) {
          e.stopPropagation();
        });
        const body = doc.querySelector("body");
        body.addEventListener("click", function () {
          tooltip.hide();
        });
      });
    },
    initFormPageFader() {
      setTimeout(() => {
        const allForms = document.getElementsByTagName("form");
        Array.from(allForms).forEach((el) => {
          var submitBtn = el.querySelector(
            'button[type="submit"]:not(.not-freeform)'
          );
          if (isNil(submitBtn)) {
            return;
          }
          el?.addEventListener("freeform-ajax-after-submit", function (event) {
            el.scrollIntoView(true);
            document.querySelector(".page-fader").classList.remove("opacity-100");
          });

          el?.addEventListener("submit", (e) => {
            if (!el.checkValidity()) {
              return;
            }
            submitBtn.innerHTML = `<span
                      class="spinner-border"
                      style="
                        margin: 0 10px 2px -5px;
                        width: 1.4rem;
                        height: 1.4rem;
                        align-self: center;
                        border-width: 0.15em;
                      "
                      role="status"
                      aria-hidden="true"
                    ></span> ${submitBtn?.innerHTML}`;
            document.querySelector(".page-fader").classList.add("opacity-100");
          });
        });
      }, 1);
    },
    showHideAddressFields() {

      // Select the checkboxes
      var checkboxes = document.querySelectorAll('.glightbox-container input[name="showAddress"]');

      // Add an event listener to each checkbox
      checkboxes.forEach(function(checkbox) {

        if(checkbox.hasAttribute('data-processed')) return;

          checkbox.setAttribute('data-processed', true);


          checkbox.addEventListener('change', function() {

              
              // Get the target from the data-target attribute
              var target = this.getAttribute('data-target');

              // Select all elements with data-address-fields=target
              var fields = document.querySelectorAll('.glightbox-container input[data-addressfields="' + target + '"]');

              var parentAutocomplete = document.querySelector('.glightbox-container input[data-' + target + ']');
              //console.log(parentAutocomplete);
              parentAutocomplete.type = this.checked ? 'hidden' : 'text';

              // Loop through the fields
              for (var i = 0; i < fields.length; i++) {

                  // If the checkbox is checked, show the field, otherwise hide it
                  fields[i].type = this.checked ? 'text' : 'hidden';
              }
          });
      });

      var form = document.querySelector('.glightbox-container form#order-details');

      // Add an event listener to the form submit event
      if(form){

      
      
        // Prevent the form from submitting when the 'enter' button is hit
        // stops the form from trying to submit before all the required fields are processed and js run i.e. mapping the address fields.
        form.addEventListener('keydown', function(event) {
          if (event && (event.key && event.key === 'Enter') || (event.keyCode && event.keyCode === 13)) {
              event.preventDefault();
              return false;
          }
        });

        form.addEventListener('submit', function(event) {

          // Select all hidden required fields
          var hiddenRequiredFields = document.querySelectorAll('.glightbox-container [type="hidden"][required][data-addressfields][value=""]');

          // If there are hidden required fields
          var clickedCheckboxes = new Set();
          if (hiddenRequiredFields.length > 0) {

            event.preventDefault();

            // Prevent the form from submitting
            var isAnyFieldEmpty = false;
        
            // Loop through the hidden required fields
            for (var i = 0; i < hiddenRequiredFields.length; i++) {

                if (hiddenRequiredFields[i].value) {
                  continue;
                }

                // Set the flag to true
                isAnyFieldEmpty = true;
              
                // Get the target from the data-address-fields attribute
                var target = hiddenRequiredFields[i].getAttribute('data-addressfields');

                // If the checkbox has already been clicked, skip this iteration
                if (clickedCheckboxes.has(target)) {
                    continue;
                }

                // Add the target to the set of clicked checkboxes
                clickedCheckboxes.add(target);
    
                // Select the checkbox with data-target=target
                var checkbox = document.querySelector('.glightbox-container input[data-target="' + target + '"]');
    
                // Check the checkbox
                checkbox.checked = true;
    
                // Trigger the change event on the checkbox
                var event = new Event('change');
                checkbox.dispatchEvent(event);

            }

              // If any required field doesn't have a value
              if (isAnyFieldEmpty) {
                // Prevent the form from submitting

                // Focus on the first hidden required field
                hiddenRequiredFields[0].focus();

                // Then blur it to trigger the validation
                hiddenRequiredFields[0].blur();

                return false;
              }
                          
          }
          else 
          {
            //allow the form to submit.
          }
        });
    }

    },
    initGLightbox() {
      const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        closeOnOutsideClick: false,
      });

      let active = null;
      

      lightbox.on("open", () => {
        
        // no matter how many lighboxs there are on the page, there's only the one here when we open.
        // when we close, there's all of them. sigh.
        active = lightbox.elements[0];
        window.activeLightbox = lightbox;
        
        //console.log(lightbox.elements[0].instance.element.dataset);
        var activeElement = active.instance.element;
        
        if(activeElement.dataset.name == "open-checkout" || activeElement.classList.contains("btn-cart"))
        {
          this.checkoutClearButton();
        }
        if(activeElement.dataset.closeOnOutsideClick && activeElement.dataset.closeOnOutsideClick == "true"){
          let gbody= document.querySelector('#glightbox-body');
          gbody.addEventListener('click', () => {
            lightbox.close();
          });

          
        }

        //we need to re-init the autocomplete.
        app.reInitCalls();
      });

      lightbox.on("close", () => {

        var activeElement = active.instance.element;

        var currentUrl = window.location.pathname;

        //so it's re-set when the next window is opened.
        window.activeLightbox = null;

        if( activeElement.dataset.refreshCartOnClose
          ||  app.isEventsPage() //cart has been closed - refresh the checkout buttin so the cart icon as items might have been removed from the cart. if we refresh this page it loses the current search filters.
        ){
          var forceOpen = false;
          if(activeElement.dataset.openCartOnRefresh){
            forceOpen = true;
          }
          app.reloadCheckout(forceOpen);
        }
        
        if(activeElement.dataset.name == "open-checkout" 
          || currentUrl.indexOf("/members/order-merchandise") === 0 //cart has been closed - refresh the page so the merch page is refreshed as items might have been removed from the cart.
        )
        {
          location.reload()
        }

        
        if (currentUrl.indexOf("/dashboard/") === 0) {
          if (
            active &&
            active.instance.element.dataset.refreshonclose &&
            active.instance.element.dataset.refreshonclose == "false"
          ) {
            return;
          } else {
            location.reload(true);
          }
        }
      });
    },
    initFreeform() {
      // More info here https://docs.solspace.com/craft/freeform/v3/developer/js-plugin/
      var fund_form = document.getElementById("membersBenevolentFund");
      if (fund_form) {
        fund_form.addEventListener("freeform-ready", function (event) {
          var name_field = fund_form.querySelector("#form-input-fullName");
          if (name_field) {
            if (first_name && last_name) {
              name_field.value = first_name + " " + last_name;
            } else {
              name_field.value = "";
            }
          }
          var email_field = fund_form.querySelector("#form-input-email");
          if (email_field) {
            if (email) {
              email_field.value = email;
            } else {
              email_field.value = "";
            }
          }
          var phone_field = fund_form.querySelector("#form-input-phone");
          if (phone_field) {
            if (phone) {
              phone_field.value = phone;
            } else {
              phone_field.value = "";
            }
          }
          var member_no_field = fund_form.querySelector("#form-input-memberNo");
          if (member_no_field) {
            if (member_no) {
              member_no_field.value = member_no;
            } else {
              member_no_field.value = "";
            }
          }
        });
      }
    },
    sprigLoad() {
      app.pageFader("remove");
      htmx.on("htmx:afterRequest", function (event) {
        app.pageFader("remove");
        app.reInitCalls();
        //console.log("htmx:afterRequest");
      });
      htmx.on("htmx:afterSettle", function (event) {
        app.reInitCalls();
        // Only affects Courses & Events search on mobile
        // Mimic the BS event and animations that are broken when the markup is updated via Sprig
        // TODO Update Courses & Events filters to Svelte same as Classified ads etc or replace with a method that reapplies the BS event to preserve the animation
        var filter_button = document.querySelector('.filter-form .btn-filter');
        var filter_container = document.querySelector('.filter-form .navbar-center');
        if (filter_button && filter_container) {
          function updateCollapse() {
            if (filter_button.classList.contains('collapsed')) {
              filter_button.classList.remove('collapsed');
              filter_button.setAttribute('aria-expanded', true);
              filter_container.classList.add('show');
              filter_container.setAttribute('aria-expanded', true);
            } else {
              filter_button.classList.add('collapsed');
              filter_button.setAttribute('aria-expanded', false);
              filter_container.classList.remove('show');
              filter_container.setAttribute('aria-expanded', false);
            }
          }
          updateCollapse();// Need to fire this immediately to prevent the button needing to be clicked twice to take effect
          filter_button.addEventListener('click', event => {
            updateCollapse();
          });
        }
        // console.log("htmx:afterSettle");
      });
      htmx.on("htmx:beforeRequest", function (event) {
        app.pageFader("add");
      });
    },
    pageFader(addRemove) {
      const pageFader = document.querySelector(".page-fader");
      if (pageFader && addRemove == "add") {
        pageFader.classList.add("opacity-100");
      } else if (pageFader && addRemove == "remove") {
        pageFader.classList.remove("opacity-100");
      }
    },
    quantityInputListener: function (input) {
      input.addEventListener(
        "change",
        function () {
          const purchasableId = input.dataset.purchasableid;
          let qty = input.value;
          const max = parseInt(input.max);
          if(qty > max){
            qty = max;
          }

          let bodyFormData = new FormData();
          bodyFormData.append("CRAFT_CSRF_TOKEN", window.csrfTokenValue);
          bodyFormData.append("action", "commerce/cart/update-cart");
          bodyFormData.append("shippingMethodHandle", "merchandiseFlateRate");

          const lineitemId = parseInt(input.dataset.lineitemid);

          let optionsKey = "options";
          let itemname = "";
          let isUpdate = lineitemId !== 0;
          if (isUpdate) {
            itemname = "lineItems[" + lineitemId + "]";
            bodyFormData.append(itemname + "[qty]", qty);
            optionsKey = itemname + "[options]";
          } else {
            itemname = "purchasableId";
            bodyFormData.append("purchasableId", purchasableId);
            bodyFormData.append("qty", qty);
          }

          let nameBadge =
            input.parentNode.parentNode.querySelector(".badge-name");
          let titleBadge =
            input.parentNode.parentNode.querySelector(".badge-title");

          if (qty > 0 && nameBadge && titleBadge) {
            if (nameBadge.value.length == 0 || titleBadge.value.length == 0) {
              alert("Please enter a Name and Title for your name badge");

              app.pageFader("remove");

              input.value = 0;

              return;
            } else {
              let allElements = document.querySelectorAll(
                ".row.product-type.name-badge"
              );

              let isDuplicate = false;

              allElements.forEach((el) => {
                let name = el.querySelector(".name-group input").value;
                let title = el.querySelector(".title-group input").value;
                if (el !== findParentElement(input)) {
                  if (name == nameBadge.value && title == titleBadge.value) {
                    isDuplicate = true;
                    return;
                  }
                }
              });

              if (isDuplicate) {
                alert(
                  "A name badge with this name and title has already been added."
                );
                app.pageFader("remove");
                input.value = 0;
                return;
              }
              bodyFormData.append(optionsKey + "[name]", nameBadge.value);
              bodyFormData.append(optionsKey + "[title]", titleBadge.value);
            }
          }
          app.pageFader("add");
          
          axios({
            method: "post",
            url: "",
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
          }).then((response) => {
            if (response.status == 200) {
              const inputs = document.querySelectorAll(".js-onchange-update");
              // Convert NodeList to Array to use filter method
              const badgeInputs = Array.from(inputs).filter((input) => {
                let parent = input.parentNode;
                while (parent && parent.nodeType === Node.ELEMENT_NODE) {
                  // Check that parent is not null and is an element
                  if (
                    parent.classList &&
                    parent.classList.contains("name-badge")
                  ) {
                    return true; // Found a parent with '.name-badge', include this input
                  }
                  parent = parent.parentNode; // Move up to the next parent
                }
                return false; // No parent with '.name-badge' found, exclude this input
              });

              const newLineItem = isUpdate
                ? response.data.cart.lineItems.find((item) => {
                    return item.id.toString() === lineitemId.toString();
                  })
                : response.data.cart.lineItems
                    .filter(
                      (item) => item.purchasableId.toString() === purchasableId
                    )
                    .find((item) => {
                      // Check if no badgeInput matches the line item id
                      return badgeInputs.every((badgeInput) => {
                        return badgeInput.name !== `lineItems[${item.id}]`;
                      });
                    });
              const subtotalElement = findSubtotalElement(input);
              if (newLineItem) {
                input.name = `lineItems[${newLineItem.id}]`;
                input.value = newLineItem.qty;
                input.dataset.lineitemid = newLineItem.id;

                subtotalElement.textContent = newLineItem.subtotalAsCurrency;
              } else {
                input.name = `purchasableId`;
                input.value = 0;
                input.dataset.lineitemid = 0;
                subtotalElement.textContent = 0;
              }

              document.querySelector(".total-sub").textContent =
                response.data.cart.itemSubtotalAsCurrency;

              if (document.querySelector(".total-courier")?.textContent) {
                document.querySelector(".total-courier").textContent =
                  response.data.cart.totalShippingCostAsCurrency;
              }

              document.querySelector(".total-value").textContent =
                response.data.cart.totalPriceAsCurrency;

              if (input.value > 0) {
                this.clearButton(input);
              }
              app.reloadCheckout();
            }
          });
        }.bind(this)
      );
    },
    checkoutClearButton: function() {
      let buttons = document.querySelectorAll(".checkout-clear")
      buttons.forEach(button => {
        button.addEventListener('click', function(e){
          let button = e.target.parentNode

          //add the fader while we process and wait for the response
          app.pageFader("add");

          const bodyFormData = new FormData();
          bodyFormData.append(`lineItems[${button.dataset.lineid}][remove]`, 1);
          bodyFormData.append("action", `commerce/cart/update-cart`);
          bodyFormData.append("CRAFT_CSRF_TOKEN", window.csrfTokenValue);
          console.log("Clicked Checkout Clear Button")



          axios({
            method: "post",
            url: "",
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
          }).then((res) => {
            button.parentNode.parentNode.remove()
  
            const cart = res.data.cart

            //do this imediatly. If the cart is empty 'close' the cart modal.
            //reload page (merch) or reload checkout (events) is handled in the close event of the lightbox.
            if(cart.lineItems.length == 0){

              window.activeLightbox.close();

            } else {
              // update the cart totals etc.
              let cartTotals = document.querySelectorAll("#cart-total")
              let shipTotals = document.querySelectorAll("#cart-shipping")
              let taxTotals = document.querySelectorAll("#cart-tax")


              cartTotals.forEach(total => {
                total.textContent = cart.totalPriceAsCurrency
              })
              shipTotals.forEach(total => {
                total.textContent = cart.totalShippingCostAsCurrency
              })
              taxTotals.forEach(total => {
                if(total.dataset.orderType == "memberSups")
                {
                  total.textContent = cart.totalTaxIncluded
                }
                else{
                  total.textContent = `$${(cart.totalPrice * 3 / 23).toFixed(2)}`
                }
              })


              document.querySelector(".total-sub").textContent =
                res.data.cart.itemSubtotalAsCurrency;

              if (document.querySelector(".total-courier")?.textContent) {
                document.querySelector(".total-courier").textContent =
                  res.data.cart.totalShippingCostAsCurrency;
              }

              document.querySelector(".total-value").textContent =
                res.data.cart.totalPriceAsCurrency;

              //all done - remove the loaded.
              app.pageFader("remove");
            }
          })
        })
      })
    },

    clearButton: function (input) {
      function findClearElement(inputElement) {
        // Starting from the input element, go up the DOM tree to find the common parent ('.row')
        let parent = inputElement;
        while (parent && !parent.classList.contains("row")) {
          parent = parent.parentNode;
        }

        // If the '.row' parent is found, find the '.col-subtotal' within it
        if (parent) {
          return parent.querySelector(".col-clear");
        } else {
          // Return null or handle the case where the '.row' parent is not found
          console.error("Clear element not found");
          return null;
        }
      }

      const parent = findParentElement(input);
      const clearButton = findClearElement(input)?.querySelector("a");
      if (parent && clearButton) {
        if (parent.classList.contains("name-badge")) {
          parent.classList.add("added-to-cart");
        } else if (input.value > 0) {
          parent.classList.add("added-to-cart");
        }
        const clearButtonClickHandler = function (e) {
          e.preventDefault();
          const lineitemId = input.dataset.lineitemid;

          if (lineitemId !== "0") {
            const bodyFormData = new FormData();
            bodyFormData.append(`lineItems[${lineitemId}][remove]`, 1);
            bodyFormData.append("action", `commerce/cart/update-cart`);
            bodyFormData.append("CRAFT_CSRF_TOKEN", window.csrfTokenValue);
            app.pageFader("add");

            axios({
              method: "post",
              url: "",
              data: bodyFormData,
              headers: { "Content-Type": "multipart/form-data" },
            }).then((response) => {
              if (parent && parent.classList.contains("name-badge")) {
                if (
                  Array.from(document.querySelectorAll(".row.name-badge"))
                    .length == 1
                ) {
                  const subtotalElement = findSubtotalElement(input);
                  input.value = 0;
                  input.dataset.lineitemid = 0;
                  input.name = `purchasableId`;
                  subtotalElement.textContent = 0;
                  clearButton.removeEventListener(
                    "click",
                    clearButtonClickHandler
                  );
                  parent.classList.remove("added-to-cart");
                } else {
                  parent.remove();
                }
              } else {
                const subtotalElement = findSubtotalElement(input);
                input.value = 0;
                input.dataset.lineitemid = 0;
                input.name = `purchasableId`;
                subtotalElement.textContent = 0;
                clearButton.removeEventListener(
                  "click",
                  clearButtonClickHandler
                );
                parent.classList.remove("added-to-cart");
              }
              document.querySelector(".total-sub").textContent =
                response.data.cart.itemSubtotalAsCurrency;

              if (document.querySelector(".total-courier")?.textContent) {
                document.querySelector(".total-courier").textContent =
                  response.data.cart.totalShippingCostAsCurrency;
              }

              document.querySelector(".total-value").textContent =
                response.data.cart.totalPriceAsCurrency;
              app.reloadCheckout();
            });
          } else {
            if (parent && parent.classList.contains("name-badge")) {
              if (
                Array.from(document.querySelectorAll(".row.name-badge"))
                  .length == 1
              ) {
                const subtotalElement = findSubtotalElement(input);
                input.value = 0;
                input.dataset.lineitemid = 0;
                input.name = `purchasableId`;
                subtotalElement.textContent = 0;
                clearButton.removeEventListener(
                  "click",
                  clearButtonClickHandler
                );
                parent.classList.remove("added-to-cart");
              } else {
                parent.remove();
              }
            } else {
              const subtotalElement = findSubtotalElement(input);
              input.value = 0;
              input.dataset.lineitemid = 0;
              input.name = `purchasableId`;
              subtotalElement.textContent = 0;
              parent.classList.remove("added-to-cart");
            }
          }
        };
        clearButton.addEventListener("click", clearButtonClickHandler);
      }
    },
    addBadgeOnClick: function (e) {
      e.preventDefault();
      let firstElement = document.querySelector(".row.product-type.name-badge");
      let allElements = document.querySelectorAll(
        ".row.product-type.name-badge"
      );
      let good = true;
      allElements.forEach((el) => {
        let qty = el.querySelector(".col-quantity input").value;
        if (qty == 0) {
          alert(
            "Please enter name, title and quantity for the previous name badge before adding another"
          );
          good = false;
        }
      });
      if (good == false) return;
      let lastElement = allElements[allElements.length - 1];
      let clonedElement = firstElement.cloneNode(true);
      let onchangeUpdateElement = clonedElement.querySelector(
        ".js-onchange-update"
      );
      if (onchangeUpdateElement) {
        // Set the 'lineitemId' attribute of the element
        onchangeUpdateElement.dataset.lineitemid = 0;
        onchangeUpdateElement.name = "purchasableId";
        onchangeUpdateElement.value = 0;

        clonedElement.querySelector(".badge-name").value = "";
        clonedElement.querySelector(".badge-title").value = "";

        clonedElement.querySelector(".col-subtotal").textContent = "$0.00";
        clonedElement.querySelector(".col-subtotal.total").dataset.lineitemid =
          "0";
        // clonedElement.classList.remove('added-to-cart');

        lastElement.insertAdjacentElement("afterend", clonedElement);
        this.quantityInputListener(onchangeUpdateElement);
        this.clearButton(onchangeUpdateElement);
      }
    },
    initPhoneNumberMask: function () {
      // Applying IMask
      const maskOptions = {
        mask: [
          {
            mask: "0061 (0{0}) 0000 0000", // Aus
            startsWith: "0061",
            lazy: true,
            country: "Australia",
          },
          {
            mask: "+64 (0{0}) 000 00000", // New Zealand landline format
            startsWith: "64",
            lazy: true,
            country: "New Zealand",
          },
          {
            mask: "02{0} 000 0000000", // New Zealand mobile format
            startsWith: "02",
            lazy: true,
            country: "New Zealand",
          },
          {
            mask: "09 000 0000000", // New Zealand landline format
            startsWith: "09",
            lazy: true,
            country: "New Zealand",
          },
          {
            mask: "07 000 0000000", // New Zealand landline format
            startsWith: "07",
            lazy: true,
            country: "New Zealand",
          },
          {
            mask: "06 000 0000000", // New Zealand landline format
            startsWith: "06",
            lazy: true,
            country: "New Zealand",
          },
          {
            mask: "03 000 0000000", // New Zealand landline format
            startsWith: "03",
            lazy: true,
            country: "New Zealand",
          },
          {
            mask: "+64 2{0} 000 0000000", // New Zealand mobile format
            startsWith: "642",
            lazy: true,
            country: "New Zealand",
          },
          {
            mask: "0800 000 0000000", // New Zealand freephone format
            startsWith: "0800",
            lazy: true,
            country: "New Zealand",
          },
          {
            mask: "0508 000 0000000", // New Zealand freephone format
            startsWith: "0508",
            lazy: true,
            country: "New Zealand",
          },
          {
            mask: "000 000 0000000", // Fallback for unknown format
            startsWith: "",
            country: "unknown",
          },
        ],
        dispatch: (appended, dynamicMasked) => {
          const number = (dynamicMasked.value + appended).replace(/\D/g, "");

          return dynamicMasked.compiledMasks.find(
            (m) => number.indexOf(m.startsWith) === 0
          );
        },
      };

      // Initialize phone mask
      const phoneMask = function () {
        const inputs = document.querySelectorAll("input[data-masked-input], input[name*='phone'], input[name*='mobile']");
        inputs.forEach(function (input) {
          let inited = input.getAttribute("data-is-masked");
          if(inited) return;
          input.setAttribute("data-is-masked", "true");
          input.type = "text";
          input.type;
          //console.log(maskOptions, "maskOptions");
          IMask(input, maskOptions);
        });
      };

      // Call the phoneMask function to initialize
      phoneMask();
    },
    merchandiseSetup() {
      const inputs = document.querySelectorAll(".js-onchange-update");
      const checkout = document.querySelector("#checkout");

      const addABadge = document.querySelector(".badge-footer .add");

      addABadge?.addEventListener("click", this.addBadgeOnClick.bind(this));

      Array.from(inputs).forEach((input, index) => {
        this.quantityInputListener(input);
        const isNameBadgeParent =
          findParentElement(input) &&
          findParentElement(input).classList.contains("name-badge");
        if (
          isNameBadgeParent &&
          Array.from(document.querySelectorAll(".row.name-badge")).length ==
            1 &&
          input.value == 0
        ) {
          return;
        }
        this.clearButton(input);
      });
    },
    membershipInvoiceRefreshTotals() {
      const format_price = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: "NZD",
      });

      //var total_el = document.querySelector('#subs-total .value');
      var total_gst_el = document.querySelector("#subs-total-gst .value");
      var subscriptions = document.querySelectorAll('[data-subscribed="true"]');
      var total = 0;
      var total_gst = 0;
      Array.prototype.forEach.call(subscriptions, function (el, i) {
        var subscription = subscriptions[i];
        total += Number(subscription.getAttribute("data-subtotal"));
        total_gst += Number(subscription.getAttribute("data-gst"));
      });
      //total_el.textContent = format_price.format(total);
      total_gst_el.textContent = format_price.format(total_gst);
    },
    membershipInvoiceCheckout() {
      const format_price = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: "NZD",
      });

      if (document.querySelector("#invoicePay")) {
        var add_buttons = document.querySelectorAll(".btn-add");
        var table = document.querySelector(".member-invoices");

        /* This is for the optional elements */
        Array.prototype.forEach.call(add_buttons, function (el, i) {
          var add_button = add_buttons[i];
          var clear_button = add_button.parentNode.querySelector(".btn-clear");

          // Hide / show buttons
          if (add_button.parentNode.getAttribute("data-subscribed") == "true") {
            add_button.style.display = "none";
            clear_button.style.display = "";
          } else {
            add_button.style.display = "";
            clear_button.style.display = "none";
          }

          var itemAttributes = add_button.parentNode.dataset;

          // Button events
          add_button.addEventListener("click", (event) => {
            event.preventDefault();
            app.pageFader("add");
            add_button.parentNode.previousElementSibling.classList.add(
              "processing-value"
            );
            add_button.parentNode.classList.add("processing-value");
            table.classList.add("processing-totals");
            add_button.style.display = "none";
            add_button.parentNode.querySelector(".btn-clear").style.display =
              "";
            add_button.parentNode.setAttribute("data-subscribed", "true");

            //checkout_el.disabled = true;
            app.membershipInvoiceRefreshTotals();

            var dataAttributes = add_button.parentNode.dataset;
            //var dataAttributes = itemAttributes.dataset;
            //console.log(1013, dataAttributes);

            // for (var key in dataAttributes) {
            //   console.log(key, dataAttributes[key]);
            // }

            var bodyFormData = {
              purchasableId: dataAttributes.purchasableid,
              CRAFT_CSRF_TOKEN: window.csrfTokenValue,
              action: "commerce/cart/update-cart",
            };

            // Define the data you want to send in the request body
            var formData = new FormData();

            for (var key in dataAttributes) {
              if (
                dataAttributes.hasOwnProperty(key) &&
                key.startsWith("save")
              ) {
                var nkey = key.replace("save", "").toLowerCase();
                bodyFormData["options[" + nkey + "]"] = dataAttributes[key];
              }
            }

            for (var property in bodyFormData) {
              formData.append(property, bodyFormData[property]);
            }

            axios({
              method: "post",
              url: "/",
              data: formData,
              headers: { "Content-Type": "multipart/form-data" },
            }).then((response) => {
              if (response.status == 200) {
                //need to loop throiugh the incart items to update the optional element with the new lineitemid.
                let lineItemsNo = response.data.cart.lineItems.length;

                for (let i = 0; i < lineItemsNo; i++) {
                  let lineItem = response.data.cart.lineItems[i];

                  if (
                    lineItem.purchasableId == dataAttributes.purchasableid &&
                    add_button.parentNode.dataset.lineitemid == 0
                  ) {
                    add_button.parentNode.dataset.lineitemid = lineItem.id;
                    //console.log(lineItem);
                    add_button.parentNode.previousElementSibling.querySelector(
                      ".value"
                    ).textContent = lineItem.salePriceAsCurrency;
                    // add_button.parentNode.parentNode.querySelector('td.gst').textContent = lineItem.taxIncludedAsCurrency;
                  }
                }
                add_button.parentNode.previousElementSibling.classList.remove(
                  "processing-value"
                );
                add_button.parentNode.classList.remove("processing-value");
                table.classList.remove("processing-totals");

                app.reloadCheckout();
              }
            });
          });
          clear_button.addEventListener("click", (event) => {
            event.preventDefault();
            app.pageFader("add");
            clear_button.parentNode.previousElementSibling.classList.add(
              "processing-value"
            );
            clear_button.parentNode.classList.add("processing-value");
            table.classList.add("processing-totals");
            clear_button.style.display = "none";
            clear_button.parentNode.querySelector(".btn-add").style.display =
              "";
            clear_button.parentNode.setAttribute("data-subscribed", "false");
            //checkout_el.disabled = true;
            app.membershipInvoiceRefreshTotals();

            var dataAttributes = clear_button.parentNode.dataset;
            //var dataAttributes = itemAttributes.dataset;
            //console.log(1013, dataAttributes);

            // for (var key in dataAttributes) {
            //   console.log(key, dataAttributes[key]);
            // }

            var bodyFormData = {
              CRAFT_CSRF_TOKEN: window.csrfTokenValue,
              action: "commerce/cart/update-cart",
            };

            // Define the data you want to send in the request body
            var formData = new FormData();

            let itemId = "lineItems[" + dataAttributes.lineitemid + "][qty]";
            formData.append(itemId, 0);

            for (var property in bodyFormData) {
              formData.append(property, bodyFormData[property]);
            }

            axios({
              method: "post",
              url: "/",
              data: formData,
              headers: { "Content-Type": "multipart/form-data" },
            }).then((response) => {
              if (response.status == 200) {
                // clear the itemid from the dataset as it's been removed from the cart.
                clear_button.parentNode.dataset.lineitemid = 0;
                clear_button.parentNode.previousElementSibling.classList.remove(
                  "processing-value"
                );
                clear_button.parentNode.classList.remove("processing-value");
                table.classList.remove("processing-totals");
                clear_button.parentNode.previousElementSibling.querySelector(
                  ".value"
                ).textContent = "$0.00";
                //clear_button.parentNode.parentNode.querySelector('td.gst').textContent = '$0.00';

                app.reloadCheckout();
              }
            });
          });
        });
      }
    },
    isEventsPage() {
      var currentUrl = window.location.pathname;
      if(currentUrl.indexOf("/education/courses-events") === 0)
      {
        return true;
      }
      return false;
    },
    reloadCheckout(forceOpen) {

      if (typeof forceOpen == "undefined") {
        var forceOpen = false;
      }

      //reload checkout
      app.pageFader("add");
      var qs = '';

      var includeTotals = document.getElementById('includeTotals')
      if(includeTotals)
      {
        qs += '&includeTotals=' + includeTotals.value;
      }
  
      var displayButton = document.getElementById('displayButton');
      if(displayButton)
      {
        qs += '&displayButton=' + displayButton.value;
      }

      var eventButton = document.getElementById('eventButton');
      if(eventButton == 0 || eventButton == null)
      {
        // are we on a courses page - this could be a search page or a course detail page.
        if(app.isEventsPage()) eventButton = 1;
        
      }
      if(eventButton)
      {
        qs += '&eventButton=' + eventButton.value;
      }

      if(qs.length > 0) qs = '?' + qs;
      

      axios({
        method: "post",
        url: "/commerce/cart" + qs,
      }).then((response) => {
        document.getElementById("cart-checkout-container").innerHTML =
          response.data;
        app.initGLightbox();
        //remove fader.
        app.pageFader("remove");

        //when we add events to the cart and close the modal we want to then force open the cart.
        if (forceOpen != false) {
          var link = document.querySelector('a[href="#checkout"]');
          var container = document.getElementById('checkout');
         
          if(link && container)
          {
            //so we don't open a empty cart.
            if(container.dataset.cartItems > 0)
            {
              link.click();
            }
          }
        }


      });
    },
    classifiedAdForm() {
      // Select the select box and the contactValue input field
      const contactDetailsSelect = document.querySelector(
        'select[name="contactDetailsSelect"]'
      );
      const contactValueInput = document.querySelector(
        'input[name="contactValue"]'
      );

      if (contactDetailsSelect && contactValueInput) {

        const defaultPhonePlaceholder = 'Enter a phone number';

        //by default the contactValueInput should be a phone/text field so mask it.
        contactValueInput.setAttribute('data-masked-input', '');
        contactValueInput.setAttribute("placeholder", defaultPhonePlaceholder);

        let parentElement = contactValueInput.parentNode;
        let currentElement = contactValueInput;
        const clonedContactValueInput = contactValueInput.cloneNode(true);

        // Add event listener to contactDetailsSelect select box
        contactDetailsSelect.addEventListener("change", function () {
          // Get the selected value
          let selectedValue = contactDetailsSelect.value;
          //console.log('selectedValue',selectedValue);
          // Update contactValue input type based on selected value
          switch (selectedValue) {
            case "email":
            case "url":
            case "phone":
              var newElement = clonedContactValueInput.cloneNode(true);
              // Replace the current element with the new one
              parentElement.replaceChild(newElement, currentElement);

              // Update the current element to the new one
              currentElement = newElement;

              //because we're using the 'phone' as the lable for the phone number we need to change it to text.
              //email and url all work ok.
              if(selectedValue == "phone") selectedValue = 'text';
              

              // Change the type of the new element based on the selected value
              newElement.type = selectedValue;
              switch (selectedValue) {
                case "email":
                  newElement.setAttribute("placeholder", "Enter a email address");
                  break;
                case "url":
                  newElement.setAttribute("placeholder", "Enter a URL");
                  break;
                case "text":
                  newElement.setAttribute("placeholder", defaultPhonePlaceholder);
                  break;
              }

              if (selectedValue === "text") {
                app.initPhoneNumberMask();
              }
              break;
          }
        });
      }

      const disabledPrice = window.disabledPrice;
      const enabledPrice = window.enabledPrice;
      const adPricing = window.adPricing;
      // console.log(adPricing);
      // console.log('disabledPrice',disabledPrice);
      // console.log('enabledPrice',enabledPrice);
      const getDefaultPriceById = function(id)  {
        // Find the object with the matching ID

        //console.log(id,adPricing);
        var product = adPricing.find(item => item.id == id);
        
        // If the product is found, return its default price
        // Otherwise, return null
        return product ? product.defaultPrice : null;
      }


      if(disabledPrice && enabledPrice){
        // if we've got these two fields then programatically watch them
        var disablePricing = document.querySelectorAll('input[name="'+ disabledPrice +'"]');
        //console.log('disablePricing.length',disablePricing.length);
        
        for (var i = 0; i < disablePricing.length; i++) {
            disablePricing[i].setAttribute('disabled', 'true');
            var priceLabel = document.querySelector('label[for="'+ disablePricing[i].id +'"]');
            priceLabel.innerHTML = priceLabel.innerHTML + ' <span class="price">'+ getDefaultPriceById(disablePricing[i].value) +'</span>';
            disablePricing[i].checked = false;
        };
    
        const commerceElement = document.querySelector('input[name="commerceElement"]');
        const isFeaturedElement = document.querySelector('input[name="featured"]');
        var enabledPricing = document.querySelectorAll('input[name="'+ enabledPrice +'"]');
        for (var i = 0; i < enabledPricing.length; i++) {
          //console.log(enabledPricing[i].id);
            var priceLabel = document.querySelector('label[for="'+ enabledPricing[i].id +'"]');
            var type = priceLabel.innerHTML.replace(/\s/g, '').toLowerCase(/\s/g, '');
            //console.log(type)
            var featured = 0;
            if(type == 'featured') {
              featured = 1;
            }
           
            enabledPricing[i].dataset['featured'] = featured; 
            priceLabel.innerHTML = priceLabel.innerHTML + ' <span class="price">'+ getDefaultPriceById(enabledPricing[i].value) +'</span>';
            if(enabledPricing[i].checked){
                commerceElement.value = enabledPricing[i].value;
            }
            enabledPricing[i].addEventListener('click', function() {
                commerceElement.value = this.value;
                isFeaturedElement.value = this.dataset['featured'];
            });


            if(featured == 0)
            {
              //check the standard by default so the product type is set.
              enabledPricing[i].click();
            }

        }

      }
    
    

        var categoryRadio = document.getElementsByName('classifiedCategory');
        var teamRadio = document.getElementsByName('classifiedCategoryTeam');
    
        var resetAllRequired = function(){
            for (var i = 0; i < categoryRadio.length; i++) {
                categoryRadio[i].removeAttribute('required');
            }
            for (var i = 0; i < teamRadio.length; i++) {
                teamRadio[i].removeAttribute('required');
            }
        }
      
        for (var i = 0; i < categoryRadio.length; i++) {
            categoryRadio[i].setAttribute('required','required');
            categoryRadio[i].addEventListener('click', function() {
                for (var j = 0; j < teamRadio.length; j++) {
                    teamRadio[j].checked = false;
                    resetAllRequired();
                }
            });
        }
    
        for (var i = 0; i < teamRadio.length; i++) {
            teamRadio[i].addEventListener('click', function() {
                for (var j = 0; j < categoryRadio.length; j++) {
                    categoryRadio[j].checked = false;
                    resetAllRequired();
                }
            });
        }
      


    },
    isAncestorHidden(element) {
      var parent = element.parentElement;

      while (parent) {
          var displayStyle = window.getComputedStyle(parent).getPropertyValue('display');
          if (displayStyle === 'none') {
              return true; // Parent is hidden
          }
          parent = parent.parentElement;
      }

      return false; // No hidden ancestor found
    },
    setUpAutoComplete(){

      const defaultKeys = ['subpremise','street_number', 'route', 'sublocality_level_1','locality', 'administrative_area_level_1', 'country', 'postal_code'];
      var AUTOCOMPLETE = (function() {
  
      var lookupAttribute = 'data-addresslookup';
      var inputs = document.querySelectorAll('input['+lookupAttribute+']');
  
  
      if(inputs.length == 0)
      {
          // {# old attribute name, changed to address-lookup as it's more descriptive #}
          lookupAttribute = 'data-autocomplete';
          var inputs = document.querySelectorAll('input['+lookupAttribute+']');
  
      }

      if (inputs.length > 0 && (typeof google === 'undefined' || typeof google.maps === 'undefined')) {

        //so we don't add this script twice
        if (window.isSetUpAutoCompleteCalled) {
            return;
        }
    
        // Set the global variable to true so we don't fire this twice.
        window.isSetUpAutoCompleteCalled = true;

        // If not loaded, create a script element and append it to the document
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + window.googleMapsApi + '&libraries=places'; // Replace YOUR_API_KEY with your actual API key

        script.onload = function () {
            // The Google Maps API has been successfully loaded
            // Now you can call your function that requires the Google Maps API
            app.setUpAutoComplete();
        };

        // Append the script to the document
        document.head.appendChild(script);
        return;

      } 
  
      for (var i = 0; i < inputs.length; i++) {
  
  
         
          (function(input) {
  
  
          if( app.isAncestorHidden(inputs[i]) )return;
          if( input.dataset.autocomplete ) return;
          
  
              var autocompleteAttr = input.getAttribute(lookupAttribute);
              var autocompleteObj = {};
              var options = {};
  
              input.dataset.autocomplete = 'processed';
  
              if (!autocompleteAttr == '') {
                  // {# Replace single quotes with double quotes #}
                  var correctedJSONString = autocompleteAttr.replace(/'/g, '"');
                  var autocompleteObj = JSON.parse(correctedJSONString) ?? {};
              }
      
              if (autocompleteObj.hasOwnProperty('countries')) {
                  options.componentRestrictions = {
                      country: autocompleteObj.countries
                  };
              }
  
  
              let keys = defaultKeys; 
  
              if (autocompleteObj.hasOwnProperty('addressPoints')) {
                  keys = autocompleteObj.addressPoints;
              }
  
              // Set the 'bounds' property to bias the results towards New Zealand
              options.bounds = new google.maps.LatLngBounds(
                  new google.maps.LatLng(-47.2865, 165.4043), // Southwest corner of the bounding box
                  new google.maps.LatLng(-33.5588, 179.2242)  // Northeast corner of the bounding box
              );
  
              var autocomplete = new google.maps.places.Autocomplete(input, options);
  
              if(  !input.getAttribute('placeholder') )
              {
                  input.setAttribute('placeholder', 'Please start typing');
              }
  
              google.maps.event.addListener(autocomplete, 'place_changed', function() {
                  var place = autocomplete.getPlace();
                  var addressPoints = {};


                  //console.log('place',place);
  
  
                  //if we've got any existing mapped values wipe these first.
                  for( var key in autocompleteObj.mapResults ){
                      var nodeList = document.getElementsByName(autocompleteObj.mapResults[key]);
                      if (nodeList.length > 0) {
                          var mappedObject = nodeList[(nodeList.length -1)];
                          mappedObject.value = '';
                      }
                     
                  }
  
                  for (var i = 0; i < place.address_components.length; i++) {
                      var addressType = place.address_components[i].types[0];
  
                      var key = place.address_components[i].types[0];
  
                      var value = 'long_name';
                      // if (i == 2) value = 'short_name';
  
                      addressPoints[key] = place.address_components[i][value];

                      // console.log(key, addressPoints[key]);

                      //does this key exist in the autocompleteObj.mapResults object?
                      if( autocompleteObj.hasOwnProperty('mapResults') ){
  
                          let value = '';
                          if( autocompleteObj.mapResults.hasOwnProperty(key) ){
                               value = addressPoints[key];
                          }
                          // console.log('key',key,autocompleteObj.mapResults[key],value);
  
                          //get the element by name
                          var nodeList = document.getElementsByName(autocompleteObj.mapResults[key]);
  
                          if (nodeList.length > 0) {
                              
                              // The element exists, so you can safely access the [0] item
                              // ... unless we're in a modal. so we'll the 'last' matching element
                              var mappedObject = nodeList[(nodeList.length -1)];
                              var subpremise = '';
                              if( key == 'route'  ){
                                if( addressPoints['subpremise'] != undefined ){
                                  subpremise = addressPoints['subpremise'] + "/";
                                }
                                value = subpremise + addressPoints['street_number'] + " " + value;
                              } 


  
                              // now set the value of the mapped object
                              mappedObject.value = value;
                          }
                          
                      }
                  }

                  
  
                  var fieldValue = "";
                  //var keys = Object.keys(addressPoints);
                  for (var i = 0; i < keys.length; i++) {
                      if( addressPoints[keys[i]] != undefined ){

                         
                          if( keys[i] == 'street_number' ){
                              if( addressPoints['subpremise'] != undefined ){
                                fieldValue += addressPoints['subpremise'] + "/";
                              }
                              fieldValue += addressPoints[keys[i]] + " ";
               
                          } else if ( keys[i] != 'subpremise' ){
                              fieldValue += addressPoints[keys[i]] + ", ";
                          }               
                      }

                      // console.log(keys[i],addressPoints[keys[i]]);
                  }
                  
                  //only do the following IF we have a specific string to show ie. town/city.
                  if (autocompleteObj.hasOwnProperty('addressPoints') && fieldValue != '') {
                    input.value = fieldValue.replace(/,\s*$/, '');
                  }
              });
          })(inputs[i]);
        }
    })();
    },

    /** check if we still need this */
    // ecommerceCheckoutAddress() {
    //   // Delivery address show/hide
    //   var $fieldsets = document.querySelectorAll('.js-address-fieldset');

    //   if ($fieldsets && $fieldsets.length) {
    //     $fieldsets.forEach(function(el) {
    //       var $addressSelects = el.querySelectorAll('.js-address-select');
    //       console.log('$addressSelects', $addressSelects.length)
    //       if ($addressSelects && $addressSelects.length) {
    //         $addressSelects.forEach(function(el) {
    //           var $radio = el.querySelector('.js-radio input');
    //           var $body = el.querySelector('.js-body');

    //           if ($radio ) {
    //             console.log('radio', $radio);
    //             console.log('body', $body);

    //             // Show/hide body based on radio button state
    //             $radio.addEventListener('change', function(ev) {

    //               if (ev.target.checked) {

    //                 var $allRadios = $addressSelects; //document.querySelectorAll('.js-address-fieldset .js-radio input');
    //                 if ($allRadios && $allRadios.length) {
    //                   $allRadios.forEach(function(radio) {
    //                     console.log(radio);
    //                     if (radio !== ev.target) {
    //                       radio.checked = false;
    //                       var $body = radio.closest('.js-address-select').querySelector('.js-body');
    //                       if ($body) {
    //                         $body.classList.add('d-none');
    //                       }
    //                     }
    //                   });
    //                 }

    //                 if ($body) $body.classList.remove('d-none');
    //               } else {
    //                 if ($body) $body.classList.add('d-none');
    //               }
    //             });

    //             if ($body && $radio.checked) {
    //               $body.classList.remove('d-none');
    //             }
    //           }
    //         });
    //       }
    //     });
    //   }
    // },
    freeformMultiPage() {
      const form = document.querySelector("form[data-freeform]");
      if (form) {
        form.addEventListener("freeform-ajax-success", function (event) {
          // Redirect the user
          if (event.response.finished) {
            //it's the final page...

            //console.log(form.dataset);
            //console.log(event.response);
            //is this the classified ads page?


            
            if(form.dataset.handle && form.dataset.handle == 'classifiedAdSubmission')
            {

             //alert('should be redirecting to the classified ad process page')
              
              app.pageFader("add");
              form.remove();

              var location = window.redirectOnFormSubmission;

              window.location.replace(`${location}?submissionId=${event.response.submissionId}&productId=${event.response.values.commerceElement}`);
            }



          } else {
            //we need to re-init all the required scripts
            app.reInitCalls();
          }
        });
      }
    },
    courseEventImage(){
      const fileInputs = document.querySelectorAll('input[data-event-image]');
      const csrfInput = document.querySelector('input[name="CRAFT_CSRF_TOKEN"]');

      fileInputs.forEach(function(fileInput) {
        //console.log('fileInput', fileInput);
          if (!fileInput.dataset.processed) { // Check if the input has not been processed
              fileInput.addEventListener("change", function(event) {
                  const formData = new FormData();
                  formData.append(fileInput.name, fileInput.files[0]);
                  formData.append('CRAFT_CSRF_TOKEN', csrfInput.value);
                  let fileName = fileInput.name;
                  const jsonData = {
                    fileName: fileInput.files[0],
                    CRAFT_CSRF_TOKEN: csrfInput.value
                };
                
                  fetch('/actions/the-cohorts-user-management-module/event-images/upload', {
                      method: 'POST',
                      headers: {
                        'Accept': 'application/json'
                    },
                      body: formData
                  })
                  .then(response => response.json())
                  .then(data => {
                      if (data.success) {


                        const img = document.createElement('img');
                        img.src = data.url;

                        const imageContainer = fileInput.parentElement.nextElementSibling.querySelector('.image');
                        imageContainer.innerHTML = '';
                        imageContainer.appendChild(img);

                        //update the hidden field
                        const assetId = fileInput.parentElement.querySelector('[data-asset-id]');
                        assetId.value = data.assetId;

                        // now clear the file value
                        fileInput.value = '';
                      } else {
                          alert('Failed to upload image. Error: ' + data.error);
                      }
                  })
                  .catch(error => {
                      console.error('Error:', error);
                  });
              });

              fileInput.dataset.processed = true; // Mark the input as processed
          }
      });
    },
    reInitCalls(){
      // should be called when 

        //re-run slimselect
        app.initSlimSelect();
        
        //we need to re-init the autocomplete.
        app.setUpAutoComplete();

        //incase we have some new phone fields in a modal
        app.initPhoneNumberMask();

        //when editing or adding a course event, we need to re-init the image upload
        app.courseEventImage();

        app.initGLightbox();

        app.classifiedAdForm();

        app.showHideAddressFields();

    },
    init: function () {
      this.initLazy();
      this.initSwipers(select(".barba-container"));
      this.initNavTabs();
      this.initMobileDropdownToggles();
      this.initHoverDropDown();
      //this.initMobileMenuCollapse()
      this.initTooltip();
      this.initFormPageFader();
      this.initGLightbox();
      this.initFreeform();
      this.matchHeights();
      this.formValidation();
      this.sprigLoad();
      this.merchandiseSetup();
      this.membershipInvoiceCheckout();
      // this.ecommerceCheckoutAddress();
      this.initMemberDirectory();
      this.initDentistSearch();
      this.initClassifiedAdsFilters();
      this.initSlimSelect();
      this.classifiedAdForm();
      this.freeformMultiPage();
      this.initPhoneNumberMask();
      this.setUpAutoComplete();
      this.courseEventImage();
      this.initInactivityModal();
    },
  };

  if (doc.querySelector("#datepicker")) {
    let startDateHiddenInput = document.getElementById("startDate"),
      startTimeHiddenInput = document.getElementById("startTime"),
      startDateTime =
        startDateHiddenInput.value + " " + startTimeHiddenInput.value,
      endDateHiddenInput = document.getElementById("endDate"),
      endTimeHiddenInput = document.getElementById("endTime"),
      endDateTime = endDateHiddenInput.value + " " + endTimeHiddenInput.value;

    const picker = new easepick.create({
      element: "#datepicker",
      elementEnd: "#endDate",
      css: [
        "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.1.6/dist/index.css",
        "/dist/easypick.css",
      ],
      zIndex: 10,
      autoApply: false,
      format: "DD/MM/YYYY, HH:mm",
      plugins: [RangePlugin, TimePlugin],
      TimePlugin: {
        format12: false
      },
      RangePlugin: {
        delimiter: " ~ ",
        startDate: new Date(startDateTime).getTime(),
        endDate: new Date(endDateTime).getTime(),
      },
      setup(picker) {
        /*
          picker.setStartDate(startDateTime);
          picker.setEndDate(endDateTime);
          */
        picker.on("select", (e) => {
          //const { select, date, target } = e.detail;
          var startDate = picker.getStartDate();
          var endDate = picker.getEndDate();
          var currentStartDate = startDate.format("DD/MM/YYYY");
          var currentStartTime = startDate.format("HH:mm");
          var currentEndDate = endDate.format("DD/MM/YYYY");
          var currentEndTime = endDate.format("HH:mm");
          startDateHiddenInput.value = currentStartDate;
          startTimeHiddenInput.value = currentStartTime;
          endDateHiddenInput.value = currentEndDate;
          endTimeHiddenInput.value = currentEndTime;
          // console.log('currentStartDate: '+currentStartDate, 'currentStartTime '+currentStartTime,' End date: '+currentEndDate,'currentEndTime: '+currentEndTime);
        });
        picker.on("change", (e) => {
          if (
            e.target &&
            e.target.classList.contains("time-plugin-custom-input")
          ) {
            const btn = picker.ui.container.querySelector(
              "footer .apply-button"
            );
            btn.disabled = false;
          }
        });
      },
    });
  }
  // if(doc.querySelector( '[data-app="container"]' ) )
  // {
  //   //barba.use(barbaPrefetch)
  //   barba.init({
  //     debug: false,
  //     schema: {
  //       prefix: 'data-app',
  //     },
  //     prefetchIgnore: '/logout',
  //     prevent: ({ el }) => el.classList && el.classList.contains('prevent')
  //   })
  //   barba.hooks.enter((data) => {
  //     app.init()
  //   })
  //   barba.hooks.leave((data) => {
  //     if(data.next.url.path == '/logout'){
  //       barba.force(data.next.url.href);
  //     }
  //   })
  // }
  // else {
  //   app.init()
  // }
  
  app.init();
})(document, window);


